/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertyRooms } from './propertyRooms';


export interface Building { 
    id?: string;
    external_id?: string;
    name?: string;
    emails?: Array<string>;
    room_types?: Array<PropertyRooms>;
}

